import { render, staticRenderFns } from "./servicos.vue?vue&type=template&id=2b30951c&scoped=true&"
import script from "./servicos.vue?vue&type=script&lang=js&"
export * from "./servicos.vue?vue&type=script&lang=js&"
import style0 from "./servicos.vue?vue&type=style&index=0&id=2b30951c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b30951c",
  null
  
)

export default component.exports